import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=071f7c45&scoped=true&"
import script from "./Acciones.vue?vue&type=script&lang=js&"
export * from "./Acciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f7c45",
  null
  
)

export default component.exports